<template>
  <div class="@container">
    <RadioGroup v-model="model">
      <RadioGroupLabel>
        <p class="text-bold mb-1">Select your Plan</p>
      </RadioGroupLabel>
      <div class="flex flex-col @[600px]:flex-row">
        <RadioGroupOption class="grow basis-0 flex" v-slot="{ checked, active }" value="standard">
          <span
            class="flex gap-2 p-4 border border-neutral-400 dark:border-neutral-700 cursor-pointer rounded-md w-full"
            :class="
              checked
                ? 'border-cardinal-500  dark:bg-white dark:text-neutral-900 dark:border-white bg-neutral-800 text-white'
                : ''
            "
          >
            <div
              class="border border-neutral-600 rounded-full h-5 w-5 relative top-0.5 flex items-center justify-center shrink-0"
            >
              <i
                class="text-sm text-cardinal-500 dark:text-cardinal"
                :class="{
                  'fas fa-circle': checked,
                  '': !checked,
                }"
              ></i>
            </div>
            <div class="flex flex-col w-full ml-3">
              <strong clas="!font-bold">Standard Membership</strong>
              <ul class="text-sm list-disc pl-4 mt-2">
                <li>Advanced Search Filters</li>
                <li>Access to our Proprietary Rankings and Insights</li>
                <li>Player Lineups on <strong>The Board</strong></li>
              </ul>
            </div>
          </span>
        </RadioGroupOption>
        <RadioGroupOption class="grow basis-0 flex" v-slot="{ checked, active }" value="portal">
          <span
            class="flex gap-2 p-4 border border-neutral-400 dark:border-neutral-700 cursor-pointer rounded-md w-full"
            :class="
              checked
                ? 'border-cardinal-500  dark:bg-white dark:text-neutral-900 dark:border-white bg-neutral-800 text-white'
                : ''
            "
          >
            <div
              class="border border-neutral-600 rounded-full h-5 w-5 relative top-0.5 flex items-center justify-center shrink-0"
            >
              <i
                class="text-sm text-cardinal-500 dark:text-cardinal"
                :class="{
                  'fas fa-circle': checked,
                  '': !checked,
                }"
              ></i>
            </div>
            <div class="flex flex-col w-full ml-3">
              <strong clas="!font-bold"> Portal Pass Membership</strong>
              <ul class="text-sm list-disc pl-4 mt-2">
                <li>Transfer Portal Notfications</li>
                <li>Compare Players on <strong>The Board</strong></li>
                <li>Includes everything included in a Standard Membership</li>
              </ul>
            </div>
          </span>
        </RadioGroupOption>
      </div>
    </RadioGroup>
  </div>
</template>

<script lang="ts" setup>
import { useVModels } from '@vueuse/core';
// const membershipType = defineModel('membershipType');
import { RadioGroup, RadioGroupLabel, RadioGroupOption } from '@headlessui/vue';
const model = defineModel<string>();
// const props = defineProps<{
//   membershipType: 'portal' | 'standard';
// }>();
// const emit = defineEmits(['update:model']);
// const { membershipType } = useVModels(props, emit);
</script>
